import { notification, Modal } from "antd";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { Fundraising } from "../domains/Fundraising";
import { FundsStore } from "./FundsStore";

export class FundEditStore {
  fundsStore: FundsStore;

  id: string = "";
  visible = false;
  loading = false;
  saving = false;
  fund?: Fundraising;

  constructor(fundsStore: FundsStore) {
    makeAutoObservable(this, {
      fundsStore: false,
    });
    this.fundsStore = fundsStore;
  }

  @action
  reload(id) {
    this.visible = true;
    this.loading = true;
    Api.fr
      .fundraising(id)
      .then((res) => {
        runInAction(() => {
          this.fund = res.data.fundraiser;
        });
      })
      .finally(() => (this.loading = false));
  }

  @action
  edit(id) {
    this.id = id;
    this.reload(id);
  }

  @action
  accept() {
    Modal.confirm({
      title: "Are you sure Accept this fundraising",
      onOk: () => {
        return Api.fr.acceptFundraising(this.fund?.id).then((res) => {
          notification.success({ message: `Fundraiser accepted.` });
          // this.reload(this.fund?.id);
          this.close();
          this.fundsStore.refresh();
        });
      },
    });
  }

  @action
  reject() {
    Modal.confirm({
      title: "Are you sure Decline this fundraising",
      onOk: () => {
        return Api.fr.rejectFundraising(this.fund?.id).then((res) => {
          notification.success({ message: `Fundraiser declined.` });
          // this.reload(this.fund?.id);
          this.close();
          this.fundsStore.refresh();
        });
      },
    });
  }

  @action
  save(values) {
    const { range, ...other } = values;
    const start = range[0].startOf("day").toISOString();
    const end = range[1].endOf("day").toISOString();
    this.saving = true;
    Api.fr
      .saveFundraising({ ...other, orgId: this.fund?.orgId, funOrgId: this.fund?.funOrgId, id: this.id, start, end })
      .then((res) => {
        this.visible = false;
        this.fundsStore.refresh();
        notification.success({ message: `Fundraiser ${values.name} saved` });
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action
  close() {
    this.visible = false;
  }
}
